import * as THREE from "three";
import { Scene, geoUtils } from "../base";

/* SizeObjects/SizesObjects
 * 寸法表示制御.
 */
export class SetbackObjects {
    private _objects: THREE.Group;
    constructor() {
        this.reset();
    }
    public reset(scene?: Scene) {
        if ((this._objects != undefined) && (scene != undefined)) {
            scene.me.remove(this._objects);
            geoUtils.disposeObject(this._objects);
        }
        this._objects = new THREE.Group;
        this._objects.visible = false;
        if (scene != undefined) scene.me.add(this._objects);
    }
    public add(obj: THREE.Object3D) {
        this._objects.add(obj);
    }
    public get visible() { return this._objects.visible; }
    public set visible(vis: boolean) {
        this._objects.visible = vis;
    }
    public get objects(): THREE.Group { return this._objects; }
}
